import { ApiAxiosInstance } from '../instances/apiAxiosInstance';

// TYPES
import { Transaction } from '@/types/TransactionType';
import { IThirdPartyDetails } from '@/types/InterfaceThirdPartyDetails';
import { MovementsVoucherResponse } from '@/types/InvoiceVoucher';
import type { IRemittanceDetailResponse } from '@/shared/common/types/remittance.type';
import { DOCUMENT_VOUCHER_PDF_VERSION } from '@/shared/common/constants/document.constant';
import type { DownloadVoucherRequest } from '@/shared/common/types/transaction.type';

export const movementClient = {
  /**
   * @deprecated Usar transactionService.getTransaction() de @/shared/common/services/transaction.service
   */
  getTransactionDetail(transactionId: string | number, productType?: string) {
    return ApiAxiosInstance.get<Transaction>(
      `/product-gateway/b2b/transaction`,
      {
        params: {
          transactionId,
          productType,
        },
      }
    );
  },
  /**
   * @deprecated Usar transactionService.getRemittance() de @/shared/common/services/transaction.service
   */
  getDetailByRemittanceId(transactionId: string | number) {
    return ApiAxiosInstance.get<IRemittanceDetailResponse>(
      `/product-gateway/b2b/transaction/remittance`,
      {
        params: {
          transactionId,
        },
      }
    );
  },
  /**
   * @deprecated Usar transactionService.getThirdParty() de @/shared/common/services/transaction.service
   */
  getThirdPartyDetails(transactionId: string | number, companyId: number) {
    return ApiAxiosInstance.get<IThirdPartyDetails>(
      `product-gateway/transaction`,
      {
        params: {
          transactionId,
          productType: 'DEPOSIT',
          customerId: companyId,
        },
      }
    );
  },

  /**
   * @deprecated Usar transactionService.downloadVoucher() de @/shared/common/services/transaction.service
   */
  downloadMovementVoucher(data: DownloadVoucherRequest) {
    return ApiAxiosInstance.post<MovementsVoucherResponse>(
      'document/b2b/vouchers/voucher-pdf',
      {
        ...data,
        version: DOCUMENT_VOUCHER_PDF_VERSION,
      }
    );
  },
  
  /**
   * @deprecated Usar transactionService.downloadSwiftCertificate() de @/shared/common/services/transaction.service
   */
  downloadSwiftCertificate(transactionId: string | number) {
    return ApiAxiosInstance.get(
      `transaction/b2b/swift-voucher/${transactionId}`
    );
  },
};
